import { Target, Eye, Heart, CheckCheck } from "lucide-react";
import { WHY } from "@/data/content";
import { Reveal } from "@/lib/motion";

const ICONS = { Target, Eye, Heart, CheckCheck };

export default function WhyUs() {
    return (
        <section id="pourquoi" className="py-24 md:py-32 bg-navy relative overflow-hidden" data-testid="why-choose-section">
            <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(50% 40% at 80% 10%, rgba(46,123,255,0.16), transparent 70%)" }} />
            <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
                <div className="text-center mb-16 max-w-2xl mx-auto">
                    <Reveal><span className="uppercase text-xs tracking-[0.2em] font-bold text-brand-red font-body">{WHY.kicker}</span></Reveal>
                    <Reveal delay={0.05}><h2 className="text-3xl md:text-4xl font-medium tracking-tight text-white mt-4 mb-5 font-display">{WHY.title}</h2></Reveal>
                    <Reveal delay={0.1}><div className="h-px w-16 bg-brand-red mx-auto mb-6" /></Reveal>
                    <Reveal delay={0.12}><p className="text-base text-white/60 font-body">{WHY.intro}</p></Reveal>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {WHY.cards.map((c, i) => {
                        const Icon = ICONS[c.icon];
                        return (
                            <Reveal key={c.title} delay={i * 0.1} y={32} className="group text-center p-8 border border-white/10 hover:border-brand-red/50 hover:bg-white/[0.03] transition-all duration-500">
                                <div className="w-14 h-14 flex items-center justify-center bg-brand-red text-white mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                    <Icon className="w-7 h-7" />
                                </div>
                                <h3 className="text-lg font-medium text-white mb-3 font-display">{c.title}</h3>
                                <p className="text-sm leading-relaxed text-white/60 font-body">{c.desc}</p>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.2} className="mt-16 text-center">
                    <p className="text-xl md:text-3xl font-light text-white/85 italic font-display">&ldquo;{WHY.quote}&rdquo;</p>
                </Reveal>
            </div>
        </section>
    );
}
